const generateUniqueName = (extension = "png") => {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).substring(2, 7);
  return `${timestamp}_${randomStr}.${extension}`;
};

export const blobToUniqueFile = (blob, extension = "png") => {
  const fname = generateUniqueName(extension);
  return new File([blob], fname, { type: blob.type });
};
